import { colors, fontSizes, fontWeights } from 'ui/theme';

export const globalOpts = {
  lang: {
    thousandsSep: ',',
  },
};

export const SMALL_CARD_HEIGHT = 416;

export const CHART_LABEL_COLOR = colors.grey90;

export const CHART_LABEL_SIZE = fontSizes.s12;

export const CHART_LABEL_WEIGHT = fontWeights.medium;

export const CHART_AXIS_TITLE_SIZE = fontSizes.s14;

export const CHART_Y_AXIS_TITLE_OFFSET = 54;

export const CHART_X_AXIS_TITLE_MARGIN = 8;

export const chartAxisLabelBaseStyles = {
  color: CHART_LABEL_COLOR,
  fontSize: CHART_LABEL_SIZE,
  fontWeight: `${CHART_LABEL_WEIGHT}`,
};
